import { render, staticRenderFns } from "./OutOfOffice.vue?vue&type=template&id=23cb0661&"
import script from "./OutOfOffice.vue?vue&type=script&lang=js&"
export * from "./OutOfOffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23cb0661')) {
      api.createRecord('23cb0661', component.options)
    } else {
      api.reload('23cb0661', component.options)
    }
    module.hot.accept("./OutOfOffice.vue?vue&type=template&id=23cb0661&", function () {
      api.rerender('23cb0661', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OutOfOffice.vue"
export default component.exports